import {
  AlertBanner,
  AlertBannerProps,
  AlertBannerType,
} from '@soluto-private/mx-asurion-ui-react';
import classNames from 'classnames';
import styles from './alert.module.scss';

function getIcon(type?: AlertBannerType) {
  switch (type) {
    case 'success':
      return 'system-alert-checkmark.svg';
    case 'warn':
      return 'system-alert-warning.svg';
    case 'error':
      return 'system-alert-alert.svg';
    default:
      return undefined;
  }
}

export const Alert = ({ className, ...props }: AlertBannerProps) => (
  <AlertBanner
    className={classNames(styles.alert, className)}
    data-testid="alert-banner"
    display="inline"
    iconSrc={getIcon(props.alertBannerType)}
    {...props}
  />
);
